import React from 'react'
import SbEditable from 'storyblok-react'
import classnames from 'classnames'

import Components from './../Components'

import styles from './styles.module.scss'

const Features = (props) => {

    const featuresClasses = classnames({
        [styles['features']]: true,
        [styles['features--horizontal']]: props.blok.direction == 'horizontal',
        [styles['features--vertical']]: props.blok.direction == 'vertical',
    })

    const styling = { width: `${props.blok.direction == 'horizontal' ? (100 / props.blok.feature_items.length) : 100}%` }

	return (
		<SbEditable content={props.blok}>
            <ul className={featuresClasses}>
                {props.blok.feature_items.map((blok, i) => {
                    return (
                        <li key={i} className={styles['features__list-item']} style={styling}>
                            {React.createElement(Components(blok.component), {
                                key: blok._uid,
                                blok: blok
                            })}
                        </li>
                    )
                })}
            </ul>
		</SbEditable>
	)
}

export default Features
